import { Injectable, inject } from '@angular/core';
import { EncryptionService } from './encryption.service';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private encryption = inject(EncryptionService);

  async add(key: string, item: unknown): Promise<void> {
    const encryptionKey = await this.getKey();
    const encryptedItem = await this.encryption.encryptData({
      key: encryptionKey,
      data: JSON.stringify(item),
    });
    sessionStorage.setItem(key, encryptedItem);
  }

  async get<T>(key: string): Promise<T | null> {
    const item = sessionStorage.getItem(key);
    if (item == null) return null;
    const encryptionKey = await this.getKey();
    const decryptedItem = await this.encryption.decryptData({ key: encryptionKey, data: item });
    return JSON.parse(decryptedItem) as T;
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }

  async getKey(): Promise<CryptoKey> {
    const item = sessionStorage.getItem('session-key');
    if (item) {
      return this.encryption.importKey(atob(item));
    }
    const newKey = await this.encryption.generateKey();
    const exported = await window.crypto.subtle.exportKey('raw', newKey);
    const exportedKeyBuffer = new Uint8Array(exported);
    sessionStorage.setItem('session-key', btoa(exportedKeyBuffer.toString()));
    return newKey;
  }
}
